import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i3 from '@angular/common/http';
import * as i1 from '@arc/arc-shared-frontend';
import { ActiveTenantStore, UserNotificationAction } from '@arc/arc-shared-frontend';
import { map, withLatestFrom, exhaustMap, switchMap, catchError } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i2 from '@ngrx/store';
import { createFeatureSelector, select, StoreModule, createSelector } from '@ngrx/store';
import { of, from } from 'rxjs';

class AccountView {
}

class ApiFilterService {
    getSortString(sort) {
        let sortString = '';
        if (sort) {
            sortString += (sort.sortAscending ? '' : '-') + sort.fieldName;
        }
        return sortString;
    }
    getFilters(filters) {
        if (!filters) {
            return [];
        }
        const queryStringParameters = [];
        for (const filter of filters) {
            let value = this.getValueFromSelectedFilter(filter);
            if (filter.operator.symbol === 'btwn') {
                value += `~${this.escapeString(filter.value2)}`;
            }
            else {
                value += filter.value2
                    ? `~${this.escapeString(filter.value2)}`
                    : '';
            }
            queryStringParameters.push(`${filter.filterBy.apiName}=${encodeURIComponent(`${filter.operator.symbol}~${value}`)}`);
        }
        return queryStringParameters;
    }
    getValueFromSelectedFilter(filter) {
        if (typeof filter.value === 'object' && filter.value.length !== undefined && filter.value.length > 0) {
            return typeof filter.value[0] === 'object'
                ? filter.value.map(x => x.value).map(this.escapeString).join('~')
                : filter.value.join('~');
        }
        const filterValue = filter.value;
        return this.escapeString(filterValue);
    }
    escapeString(str) {
        if (str == null) {
            return str;
        }
        return str.replace('/', '//').replace('~', '/~');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: ApiFilterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: ApiFilterService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: ApiFilterService, decorators: [{
            type: Injectable
        }] });

/* tslint:disable */
class AccountV1Service {
    constructor(configSettings, apiFilterService, http) {
        this.configSettings = configSettings;
        this.apiFilterService = apiFilterService;
        this.http = http;
    }
    get baseUrl() {
        return this.configSettings.getconfig('accountServiceUrl');
    }
    getAccounts(tenantId, filters, sort, pageSize, pageNumber) {
        const queryParameters = [];
        if (filters != null)
            queryParameters.push(...this.apiFilterService.getFilters(filters).map(c => `filter=${encodeURIComponent(c)}`));
        if (sort != null)
            queryParameters.push(`sort=${encodeURIComponent(this.apiFilterService.getSortString(sort))}`);
        if (pageSize != null)
            queryParameters.push(`pageSize=${pageSize}`);
        if (pageNumber != null)
            queryParameters.push(`first=${pageNumber}`);
        const queryString = queryParameters.length > 0 ? `?${queryParameters.join('&')}` : '';
        const uri = `${this.baseUrl}/v1/tenants/${tenantId}/accounts${queryString}`;
        return this.http.get(uri, { observe: 'response' }).pipe(map(resp => {
            return {
                accounts: resp.body,
                totalAccounts: +resp.headers.get('x-paging-totalrecordcount')
            };
        }));
    }
    getAccountById(tenantId, accountId) {
        const uri = `${this.baseUrl}/v1/tenants/${tenantId}/accounts/${accountId}`;
        return this.http.get(uri);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountV1Service, deps: [{ token: i1.AppConfigSettings }, { token: ApiFilterService }, { token: i3.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountV1Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.AppConfigSettings }, { type: ApiFilterService }, { type: i3.HttpClient }] });

/* tslint:disable */
class FinancialDocumentV1Service {
    constructor(configSettings, http) {
        this.configSettings = configSettings;
        this.http = http;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: FinancialDocumentV1Service, deps: [{ token: i1.AppConfigSettings }, { token: i3.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: FinancialDocumentV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: FinancialDocumentV1Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.AppConfigSettings }, { type: i3.HttpClient }] });

class AccountListActionTypes {
    static { this.LoadAccountList = '[Account] Load Account List'; }
    static { this.AccountListLoaded = '[Account] Account List Loaded'; }
    static { this.AccountListLoadedFailed = '[Account] Account List Loaded Failed'; }
}
class LoadAccountListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountListActionTypes.LoadAccountList;
    }
}
class AccountListLoadedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountListActionTypes.AccountListLoaded;
    }
}
class AccountListLoadedFailedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountListActionTypes.AccountListLoadedFailed;
    }
}

const initialAccountListState = { accounts: [], totalAccounts: 0, isLoading: false };
function accountListReducer(state = initialAccountListState, action) {
    switch (action.type) {
        case AccountListActionTypes.LoadAccountList: {
            return {
                ...state,
                isLoading: true
            };
        }
        case AccountListActionTypes.AccountListLoadedFailed: {
            return {
                ...state,
                isLoading: false
            };
        }
        case AccountListActionTypes.AccountListLoaded: {
            const payload = action.payload;
            return {
                ...state,
                accounts: [...payload.accounts],
                isLoading: false,
                totalAccounts: payload.totalAccounts
            };
        }
        default: {
            return state;
        }
    }
}

class AccountActionTypes {
    static { this.LoadAccountDetail = '[Account] Load Account Detail'; }
    static { this.ClearAccountDetail = '[Account] Clear Account Detail'; }
    static { this.AccountDetailLoaded = '[Account] Account Detail Loaded'; }
    static { this.AccoutnDetailLoadFailed = '[Account] Account Detail Load Failed'; }
}
class LoadAccountDetailAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.LoadAccountDetail;
    }
}
class AccountDetailLoadedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.AccountDetailLoaded;
    }
}
class AccountDetailLoadFailedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.AccoutnDetailLoadFailed;
    }
}
class ClearAccountDetailAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.ClearAccountDetail;
    }
}

const initialAccountState = {
    account: {
        accountId: '',
        billName: '',
        address: [{
                address1: '',
                address2: '',
                address3: '',
                address4: '',
                address5: '',
                city: '',
                country: '',
                state: '',
                zip: '',
            }],
        createDate: '',
        accountNumber: '',
        openBalance: null,
        currency: ''
    },
    isLoading: false
};
function accountReducer(state = initialAccountState, action) {
    switch (action.type) {
        case AccountActionTypes.LoadAccountDetail: {
            return {
                ...state,
                isLoading: true
            };
        }
        case AccountActionTypes.AccountDetailLoaded: {
            return {
                ...state,
                isLoading: false,
                account: { ...action.payload }
            };
        }
        case AccountActionTypes.AccoutnDetailLoadFailed: {
            return {
                ...state,
                isLoading: false
            };
        }
        case AccountActionTypes.ClearAccountDetail: {
            return { ...initialAccountState };
        }
        default: {
            return state;
        }
    }
}

const reducers = {
    account: accountReducer,
    accountList: accountListReducer,
};
const getAccountState = createFeatureSelector('account');

class AccountListEffects {
    constructor(actions$, store, accountService) {
        this.actions$ = actions$;
        this.store = store;
        this.accountService = accountService;
        this.allAccount$ = createEffect(() => this.actions$.pipe(ofType(AccountListActionTypes.LoadAccountList), map((action) => action.payload), withLatestFrom(this.store.pipe(select(ActiveTenantStore))), exhaustMap(([params, tenant]) => {
            return this.accountService.getAccounts(tenant.tenantId, params.filters, params.sort, params.pageSize, params.pageNumber).pipe(switchMap(accountsResult => {
                return of({
                    accounts: accountsResult.accounts,
                    openBalance: [], // This was a <OpenBalanceForAccountV1[]>[], but will likely change when we get open balances again
                    error: null,
                    totalRecords: accountsResult.totalAccounts
                });
            }), switchMap(result => {
                if (result.error != null) {
                    return from([
                        new UserNotificationAction({ type: 'error', message: 'Error while loading open balance' }),
                        new AccountListLoadedAction({ accounts: result.accounts, totalAccounts: result.totalRecords })
                    ]);
                }
                else {
                    return from([
                        new AccountListLoadedAction({ accounts: result.accounts, totalAccounts: result.totalRecords })
                    ]);
                }
            }), catchError(error => {
                const userNotificationAction = new UserNotificationAction({
                    type: 'error',
                    message: 'Error while loading accounts',
                });
                const loadErrorAction = new AccountListLoadedFailedAction({ error: error });
                const actions = [userNotificationAction, loadErrorAction];
                return from(actions);
            }));
        })));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountListEffects, deps: [{ token: i1$1.Actions }, { token: i2.Store }, { token: AccountV1Service }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountListEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountListEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.Actions }, { type: i2.Store }, { type: AccountV1Service }] });

class AccountEffects {
    constructor(actions$, store, accountService) {
        this.actions$ = actions$;
        this.store = store;
        this.accountService = accountService;
        this.loadAccount$ = createEffect(() => this.actions$.pipe(ofType(AccountActionTypes.LoadAccountDetail), map((action) => action.payload), withLatestFrom(this.store.pipe(select(ActiveTenantStore))), exhaustMap(([params, tenant]) => {
            return this.accountService
                .getAccountById(tenant.tenantId, params.accountId)
                .pipe(map(account => new AccountDetailLoadedAction(account)), catchError(error => {
                const userNotificationAction = new UserNotificationAction({
                    type: 'error',
                    message: 'Error while loading account',
                });
                const loadFailedAction = new AccountDetailLoadFailedAction({ error: error });
                const actions = [userNotificationAction, loadFailedAction];
                return from(actions);
            }));
        })));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountEffects, deps: [{ token: i1$1.Actions }, { token: i2.Store }, { token: AccountV1Service }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.Actions }, { type: i2.Store }, { type: AccountV1Service }] });

const effects = [AccountListEffects, AccountEffects];

class AccountStoreModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountStoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.0", ngImport: i0, type: AccountStoreModule, imports: [CommonModule, i2.StoreFeatureModule, i1$1.EffectsFeatureModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountStoreModule, providers: [
            ApiFilterService
        ], imports: [CommonModule,
            StoreModule.forFeature('account', reducers),
            EffectsModule.forFeature(effects)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: AccountStoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        StoreModule.forFeature('account', reducers),
                        EffectsModule.forFeature(effects)
                    ],
                    exports: [],
                    providers: [
                        ApiFilterService
                    ]
                }]
        }] });

const AccountListStore = createSelector(getAccountState, state => state.accountList.accounts);
const getTotalAccounts = createSelector(getAccountState, (state) => {
    return state.accountList.totalAccounts;
});
const getAccountsIsLoading = createSelector(getAccountState, (state) => {
    return state.accountList.isLoading;
});

const SingleAccountStore = createSelector(getAccountState, state => state.account.account);
const getIsAccountLoading = createSelector(getAccountState, state => state.account.isLoading);

class ArcAccountDataModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: ArcAccountDataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.0", ngImport: i0, type: ArcAccountDataModule, imports: [AccountStoreModule], exports: [AccountStoreModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: ArcAccountDataModule, imports: [AccountStoreModule, AccountStoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.0", ngImport: i0, type: ArcAccountDataModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [AccountStoreModule],
                    exports: [AccountStoreModule],
                    providers: []
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AccountActionTypes, AccountDetailLoadFailedAction, AccountDetailLoadedAction, AccountEffects, AccountListActionTypes, AccountListEffects, AccountListLoadedAction, AccountListLoadedFailedAction, AccountListStore, AccountStoreModule, AccountV1Service, AccountView, ArcAccountDataModule, ClearAccountDetailAction, FinancialDocumentV1Service, LoadAccountDetailAction, LoadAccountListAction, SingleAccountStore, effects, getAccountState, getAccountsIsLoading, getIsAccountLoading, getTotalAccounts, reducers };
